
export function isRtl(text: string): boolean {
  if (!text) return false;
  
  // Regex for RTL characters (Hebrew, Arabic, Persian, etc.)
  const rtlRegex = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
  
  // Check if the first 100 characters contain any RTL character
  // This is usually sufficient to determine the direction of the text
  const userTextSample = text.substring(0, 100);
  
  return rtlRegex.test(userTextSample);
}
